module.exports = __webpack_public_path__ + "ed6b2215974ff31504c33282588d51b1.png";